import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index";
import axios from "axios";
import VueAxios from "vue-axios";
window.$ = window.jQuery = require("jquery");
import VueCountdown from "@chenfengyuan/vue-countdown";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import GiGridImages from "@chinhpd/vue3-grid-images";
import Toaster from "@meforma/vue-toaster";
import Vue3Autocounter from "vue3-autocounter";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

const app = createApp(App);
app.use(router);
app.use(VueAxios, axios);
app.use(moment);
app.use(Toaster);
app.component(VueCountdown.name, VueCountdown);
app.component("Datepicker", Datepicker);
app.component("GiGridImages", GiGridImages);
app.component("vue3-autocounter", Vue3Autocounter);
app.component(PulseLoader);

// app.config.globalProperties.backendUrl = "http://10.0.6.6:9006/api";
// app.config.globalProperties.backendImgUrl =
//   "http://10.0.6.6:9006/public/uploads/images";
// app.config.globalProperties.backendFileUrl = "http://10.0.6.6:9006/public";

// app.config.globalProperties.backendUrl = 'https://maritimeadmin.rndghit.com/api';
// app.config.globalProperties.backendImgUrl = 'https://maritimeadmin.rndghit.com/public/uploads/images';
// app.config.globalProperties.backendFileUrl = 'https://maritimeadmin.rndghit.com/public';

app.config.globalProperties.backendUrl =
  "https://event.bmu.edu.bd/laravel-app/api";
app.config.globalProperties.backendImgUrl =
  "https://event.bmu.edu.bd/laravel-app/public/uploads/images";
app.config.globalProperties.backendFileUrl =
  "https://event.bmu.edu.bd/laravel-app/public";

app.config.globalProperties.$filters = {
  timeAgo(date) {
    return moment(date).fromNow();
  },

  timeRemain(targetDate) {
    let start = Date.now();
    let end = moment(targetDate);
    let duration = moment.duration(end.diff(start));
    //let time = duration.asDays();
    return duration;
  },

  myDateFormate(date) {
    return moment(date).format("DD MMM YYYY");
  },
  fullMonthDateFormate(date) {
    return moment(date).format("DD MMMM YYYY");
  },
  str_limit(value, size) {
    if (!value) return "";
    value = value.toString();

    if (value.length <= size) {
      return value;
    }
    return value.substr(0, size) + "...";
  },
};
app.mount("#app");
